import React, { useState, useEffect, useRef } from 'react'
import LatestReservations from './partials/LatestReservations'
import { Link, useHistory } from 'react-router-dom'
import { useAuthDataContext } from '../../../_providers/Auth'
import { fromInfo, trans } from '../../../_providers/Translation'

//partials
import Location from './partials/Location'
import Reservation from './partials/Reservation'
import ActivityLog from './partials/ActivityLog'
import CurrentDataChart from './partials/CurrentDataChart'
import Finances from './partials/Finances'
import EmployeesReservationsChart from './partials/EmployeesReservationsChart'
import viberIcon from '../../../assets/img/icons/sms/viber.png'
import whatsAppIcon from '../../../assets/img/icons/sms/whatsapp.png'
import smsIcon from '../../../assets/img/icons/sms/sms.png'
import Help from '../../partials/Help'
import ManualOverview from './partials/ManualOverview'
import InvoicePaymentsStats from './partials/InvoicePaymentsStats'
import StoragePartsStats from './partials/StoragePartsStats'
import TodosStatsPerEmployee from './partials/TodosStatsPerEmployee'
import ReservationStats from './partials/ReservationStats'
import CustomersChart from './partials/CustomersChart'
import { Menu, MenuItem } from '@mui/material'
import BonusPolicies from './partials/BonusPolicies'
import ContractorsChart from './partials/ContractorsChart'
import FinancesMain from './partials/FinancesMain'
import SentMessagesChart from './partials/SentMessagesChart'
import RemainingMessagesChart from './partials/RemainingMessagesChart'

function Dashboard() {
    const auth = useAuthDataContext()
    const history = useHistory()

    const addAddressReservationButtonRef = useRef(null)

    const [openButtonDropdown, setOpenButtonDropdown] = useState(null)

    const handleNewTask = () => history.push('/schedule/reservations/address/add')
    const handleNewServiceReservation = () => history.push('/schedule/reservations/service/add')

    function handleButtonSubmenuClick(e) {
        e.stopPropagation()
        e.preventDefault()

        setOpenButtonDropdown(addAddressReservationButtonRef.current)
    }

    return (
        <div id="dashboard">
            <div className="top-part">
                <div className="left">
                    <h1 className="page-heading">
                        {trans('headings.dashboard')}
                    </h1>
                    <p className="page-subheading">
                        {trans('subheadings.dashboard')}
                    </p>
                </div>
                <div className="right" style={{ display: 'flex' }}>
                    <Menu
                        anchorEl={openButtonDropdown}
                        keepMounted
                        open={Boolean(openButtonDropdown)}
                        onClose={() => setOpenButtonDropdown(null)}
                    >
                        <MenuItem onClick={handleNewTask}>
                            {trans('buttons.addAddressReservation')}
                        </MenuItem>
                        <MenuItem onClick={handleNewServiceReservation}>
                            {trans('buttons.addServiceReservation')}
                        </MenuItem>
                    </Menu>
                    <button onClick={handleNewTask} className="button button-add with-dropdown" ref={addAddressReservationButtonRef}>
                        {trans('buttons.addAddressReservation')}
                        <i className="menu" onClick={handleButtonSubmenuClick}>

                        </i>
                    </button>
                </div>
            </div>

            <div className='row'>
                <div className='col'>
                    <div className="pannel">
                        <ReservationStats />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <div className='pannel'>
                        <Location />
                    </div>
                </div>
            </div>


            <div className='row'>
                <div className="col">
                    <div
                        className="pannel"
                    >
                        <TodosStatsPerEmployee
                            title={trans('nav.todos')}
                            endpoint="dashboard/todos-stats-per-employee"
                        />
                    </div>
                </div>
                <div className="col">
                    <div
                        className="pannel"
                    >
                        <ActivityLog />
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col'>
                    <div className='pannel'>
                        <BonusPolicies />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <div className='pannel'>
                        <FinancesMain />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="pannel">
                        <InvoicePaymentsStats
                            title={trans('nav.invoices')}
                            endpoint="dashboard/invoices-payments/stats"
                            colors={['#1E40AF', '#2563EB', '#3B82F6', '#60A5FA']}
                        />
                    </div>
                </div>
                <div className='col'>
                    <div className="pannel">
                        <Finances />
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className="col">
                    <div className="pannel">
                        <ContractorsChart />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <div className='pannel'>
                        <StoragePartsStats
                            title={trans('tabs.parts')}
                            endpoint="dashboard/storage-parts/stats"
                            colors={['#4F46E5', '#7C3AED', '#A855F7', '#C084FC', '#DDD6FE', '#3B82F6', '#1E40AF', '#312E81']}
                            donut={true}
                            size={220}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <div className="pannel">
                        <SentMessagesChart />
                    </div>
                </div>
                <div className='col'>
                    <div className="pannel">
                        <RemainingMessagesChart />
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col'>
                    <div className="pannel">
                        <CustomersChart />
                    </div>
                </div>
                <div className='col'>
                    <div className="pannel">
                        <ManualOverview
                            title={trans('nav.manuals')}
                            endpoint="dashboard/manuals/overview"
                            colors={['#1E40AF', '#2563EB', '#3B82F6', '#60A5FA']}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard